import { Badge } from '@@/Badge';

export function ExternalBadge() {
  return <Badge type="info">External</Badge>;
}
